// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style_container__DLvJ-{
    width:55vw;
    /* height: 70vh; */
    /* min-height: 70vh;
    max-height: 70vh; */
    padding:10px;
    overflow:hidden;
    height:100%;
}
.style_button__oIpEM{
    border-radius:8px !important;
    min-width: 118px;
    display: flex;
    /* text-align: center; */
    justify-content: center;
    align-items: center;
    margin-top: 20px;
}
.style_container__DLvJ->div:nth-child(1){
    margin-top:10px;
}
.style_container__DLvJ->p:nth-child(2){
    margin-top: 20px;
}
.style_scrollDivOuter__kABjW{
    height: calc(100% - 238px) !important;
    min-height:  calc(100% - 238px) !important;
    max-height: calc(100% - 238px) !important
}
.style_scrollDivInside__mB2Qm{
    height: calc(100% - 80px) !important;
    min-height:  calc(100% - 80px) !important;
    max-height: calc(100% - 80px) !important
}
@media only screen and (max-width: 1200px) {
    .style_container__DLvJ-{
        width:70vw;
    }
}

@media only screen and (max-width: 800px) {
    .style_container__DLvJ-{
        width:90vw;
    }
}`, "",{"version":3,"sources":["webpack://./../src/renderer/components/UserInfo/style.module.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,kBAAkB;IAClB;uBACmB;IACnB,YAAY;IACZ,eAAe;IACf,WAAW;AACf;AACA;IACI,4BAA4B;IAC5B,gBAAgB;IAChB,aAAa;IACb,wBAAwB;IACxB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,eAAe;AACnB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,qCAAqC;IACrC,0CAA0C;IAC1C;AACJ;AACA;IACI,oCAAoC;IACpC,yCAAyC;IACzC;AACJ;AACA;IACI;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,UAAU;IACd;AACJ","sourcesContent":[".container{\n    width:55vw;\n    /* height: 70vh; */\n    /* min-height: 70vh;\n    max-height: 70vh; */\n    padding:10px;\n    overflow:hidden;\n    height:100%;\n}\n.button{\n    border-radius:8px !important;\n    min-width: 118px;\n    display: flex;\n    /* text-align: center; */\n    justify-content: center;\n    align-items: center;\n    margin-top: 20px;\n}\n.container>div:nth-child(1){\n    margin-top:10px;\n}\n.container>p:nth-child(2){\n    margin-top: 20px;\n}\n.scrollDivOuter{\n    height: calc(100% - 238px) !important;\n    min-height:  calc(100% - 238px) !important;\n    max-height: calc(100% - 238px) !important\n}\n.scrollDivInside{\n    height: calc(100% - 80px) !important;\n    min-height:  calc(100% - 80px) !important;\n    max-height: calc(100% - 80px) !important\n}\n@media only screen and (max-width: 1200px) {\n    .container{\n        width:70vw;\n    }\n}\n\n@media only screen and (max-width: 800px) {\n    .container{\n        width:90vw;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `style_container__DLvJ-`,
	"button": `style_button__oIpEM`,
	"scrollDivOuter": `style_scrollDivOuter__kABjW`,
	"scrollDivInside": `style_scrollDivInside__mB2Qm`
};
export default ___CSS_LOADER_EXPORT___;
